var map = {
	"./de/group-logo.png": "2qh/",
	"./en/group-logo.png": "v71F",
	"./es/group-logo.png": "E6qe",
	"./fr/group-logo.png": "/8ru",
	"./ja/group-logo.png": "hQaa",
	"./ko/group-logo.png": "sdHP",
	"./pt/group-logo.png": "KyFW",
	"./ru/group-logo.png": "dH7T",
	"./tc/group-logo.png": "mkqk",
	"./th/group-logo.png": "+3Mx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "E6L5";